import React from "react";
import { MENU } from "../mock";

function PricedItem({ item }) {
  return (
    <div className="flex items-baseline gap-3 py-2.5 group">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-display text-lg text-[#16110E] font-medium">
            {item.name}
          </span>
          {item.isNew && (
            <span className="label-mono text-[9px] bg-[#D5521B] text-[#FBF6EA] px-2 py-0.5 rounded-full">
              New
            </span>
          )}
        </div>
        {item.desc && (
          <span className="text-sm text-[#8A7C68] italic">{item.desc}</span>
        )}
      </div>
      <span className="flex-1 border-b border-dotted border-[#CDBE9E] translate-y-[-4px] mx-1 hidden sm:block" />
      <span className="font-mono text-[#D5521B] font-bold text-sm shrink-0">
        {item.price}
      </span>
    </div>
  );
}

function MenuCard({ section }) {
  return (
    <div className="reveal bg-[#FBF6EA] rounded-2xl border border-[#DCCFB4] p-6 md:p-8 h-full shadow-[0_20px_40px_-30px_rgba(60,40,20,0.4)]">
      <div className="flex items-center justify-between mb-1">
        <span className="label-mono text-[#8A7C68]">{section.no}</span>
        <span className="label-mono text-[#D5521B]">{section.badge}</span>
      </div>
      <h3 className="font-display text-3xl font-bold text-[#16110E] mt-2">
        {section.title}
      </h3>
      <p className="text-sm text-[#8A7C68] mt-2 mb-4">{section.note}</p>
      <div className="border-t border-[#DCCFB4] pt-2">
        {section.type === "list" ? (
          <div className="grid grid-cols-2 gap-x-4 gap-y-1 pt-2">
            {section.items.map((it) => (
              <div
                key={it}
                className="flex items-center gap-2 py-1.5 font-display text-[#16110E]"
              >
                <span className="text-[#E0971A]">✦</span> {it}
              </div>
            ))}
          </div>
        ) : (
          section.items.map((it) => <PricedItem key={it.name} item={it} />)
        )}
      </div>
    </div>
  );
}

export default function MenuSection() {
  return (
    <section id="menu" className="py-24 md:py-32 grain-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <span className="label-mono text-[#D5521B]">{MENU.eyebrow}</span>
          <h2 className="font-display font-black text-5xl md:text-7xl text-[#16110E] mt-4">
            {MENU.title}
          </h2>
          <p className="mt-5 text-[#5E5548] leading-relaxed">{MENU.blurb}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {MENU.sections.map((s) => (
            <MenuCard key={s.no} section={s} />
          ))}
        </div>

        <p className="text-center label-mono text-[#8A7C68] mt-12">
          psst — every meal · 2 sides · rice &amp; cornbread
        </p>
      </div>
    </section>
  );
}
